var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideotape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Menu/Off",
    clipPath: "url(#clip0_899_5654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 0V3H20V0H4V3H2V0H0V24H2V21H4V24H20V21H22V24H24V0H22ZM22 5V7H20V5H22ZM20 13H22V15H20V13ZM20 11V9H22V11H20ZM18 2V11H6V2H18ZM2 11V9H4V11H2ZM4 13V15H2V13H4ZM4 5V7H2V5H4ZM2 19V17H4V19H2ZM6 22V13H18V22H6ZM20 19V17H22V19H20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_5654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideotape);
export default __webpack_public_path__ + "static/media/ic_videotape.323cabb45e22efe1934a6cfff4ae4ce1.svg";
export { ForwardRef as ReactComponent };